var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGovernment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.998 3.008a.311.311 0 0 1 .222.03l4.167 2.502a.386.386 0 0 1 .098.576.361.361 0 0 1-.275.128h-.566v4.442h.223c.091 0 .184-.007.273.02.196.052.356.22.402.421.024.092.015.188.017.281a.59.59 0 0 1-.148.402A.559.559 0 0 1 12 12H4.15a.557.557 0 0 1-.39-.16.587.587 0 0 1-.176-.421c.002-.094-.007-.19.014-.282a.582.582 0 0 1 .242-.356.553.553 0 0 1 .31-.095h.34V6.245h-.553a.364.364 0 0 1-.262-.11.395.395 0 0 1-.046-.47.407.407 0 0 1 .13-.127l4.085-2.452c.05-.029.097-.065.155-.078Zm-.183 2.077-.365.759c-.281.043-.562.083-.844.126a.221.221 0 0 0-.178.15.23.23 0 0 0 .056.235l.61.61-.143.859a.23.23 0 0 0 .048.188.217.217 0 0 0 .184.078.29.29 0 0 0 .124-.045l.717-.387.76.41a.215.215 0 0 0 .22-.013.227.227 0 0 0 .096-.222l-.145-.868.576-.576a.296.296 0 0 0 .09-.123A.229.229 0 0 0 9.525 6c-.042-.027-.093-.032-.14-.039l-.788-.117-.37-.77a.24.24 0 0 0-.083-.103.215.215 0 0 0-.235-.005.248.248 0 0 0-.095.118Zm-2.149 4.53c-.002.055-.006.113.019.163.033.073.11.122.188.118h4.415c.047 0 .095.005.139-.015a.206.206 0 0 0 .124-.182c.001-.05.004-.102-.017-.148a.202.202 0 0 0-.185-.123H5.925c-.036 0-.073-.003-.108.006a.206.206 0 0 0-.15.182Zm-.01.985c-.003.057-.006.118.022.17.034.07.11.115.186.112h4.475a.204.204 0 0 0 .2-.178c.007-.077.006-.166-.052-.225-.047-.055-.12-.072-.19-.067H5.936c-.043 0-.086-.003-.128.007a.206.206 0 0 0-.15.18Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.c2e4d803bb79244d72021ed5097a0c08.svg";
export { ForwardRef as ReactComponent };